
import { Route } from '@/app/router'

const Account = () => import('./index.vue')
const AccountEdit = () => import('./children/AccountEdit')
const AccountChangePassword = () => import('./children/AccountChangePassword')
const SystemBanner = () => import('./children/SystemBanner')
const LanguageSettings = () => import('./children/LanguageSettings')
const ThemeSettings = () => import('./children/ThemeSettings')
const AccountMfa = () => import('./children/AccountMfa')

export default [
	new Route('/account', Account).children([
		new Route('/', AccountEdit).as('Dashboard:Account').meta({ order: 1 }),
		new Route('change-password', AccountChangePassword).as('Dashboard:Account:ChangePassword').meta({ order: 2 }),
		new Route('language-settings', LanguageSettings).as('Dashboard:Account:LanguageSettings').meta({ order: 3 }),
		new Route('theme-settings', ThemeSettings).as('Dashboard:Account:ThemeSettings').meta({ order: 4 }),
		new Route('mfa', AccountMfa).as('Dashboard:Account:Mfa').meta({ order: 5 }),
		new Route('system-banner', SystemBanner).as('Dashboard:Account:SystemBanner').meta({ order: 6 }).permissions(['IS_ADMIN'])
	])
]
